import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ThirdPartiesCmp_SomePeople_QueryDocument = graphql(`
  query ThirdPartiesCmp_SomePeople_Query(
    $statusId: Id!
    $isInternal: Boolean!
  ) {
    findSomePeople(filter: { statusId: $statusId, isInternal: $isInternal }) {
      _id
      ...ThirdPartiesCmp_Person_Fragment
    }
  }
`);

export type ThirdPartiesCmp_SomePerson = ResultOf<
  typeof ThirdPartiesCmp_SomePeople_QueryDocument
>['findSomePeople'][number];
